import React, {useContext, useEffect, useRef, useState} from "react";
import {Button, Checkbox, ConfigProvider, Form, Input, InputNumber, Select, Table, theme, TreeSelect} from "antd";
import {WebSocketContext} from "../../components/websocket/WebSocketContext";
import {dateFormatterNoYear, hoursFormatter, Markets} from "../../utils";
import {productServices, tournamentServices} from "../../api";
import {sessionServices} from "../../api/session";

const beepPlayer = new Audio("/beep.mp3");

export const OddVariations = (props) => {

    const [user] = useState(localStorage.getItem('token'));
    const userBookmakers = JSON.parse(localStorage.getItem('products') || JSON.stringify({oddvariations: []})).oddvariations

    const [droppingBookmakers, setDroppingBookmakers] = useState({})
    const [data, setData] = useState({})
    const [lastDrop, setLastDrop] = useState(null)
    const [droppingOdds, setDroppingOdds] = useState([]);
    const [droppingOddsList, setDroppingOddsList] = useState([]);
    const [bookmakers, setBookmakers] = useState([])
    const [allTournaments, setAllTournaments] = useState({})
    const [allMarkets] = useState(Object.values(Markets).reduce((acc, market) => {
        if (!acc[market.sport]) {
            acc[market.sport] = {};
        }
        if (!acc[market.sport][market.marketType]) {
            acc[market.sport][market.marketType] = {};
        }
        acc[market.sport][market.marketType][market.id] = market;
        return acc;
    }, {}))
    const [markets, setMarkets] = useState(Object.values(Markets).map(m => m.id.toString()))
    const [threshold, setThreshold] = useState(0)
    const [from, setFrom] = useState(1)
    const [to, setTo] = useState(1)
    const [date, setDate] = useState(0)
    const [search, setSearch] = useState('')
    const [showFrom, setShowFrom] = useState(0)
    const [tournaments, setTournaments] = useState([])
    const [hide, setHide] = useState([])
    const [sound, setSound] = useState(false)
    const [onlyRemoved, setOnlyRemoved] = useState(false)
    const {socket} = useContext(WebSocketContext);

    const filtersRef = useRef({
        bookmakers,
        markets,
        threshold,
        date,
        search,
        from,
        to,
        showFrom,
        tournaments,
        hide,
        onlyRemoved
    });
    const lastUpdate = useRef(0);
    const lastSearch = useRef(search);
    const lastHide = useRef(hide);


    useEffect(() => {
        productServices
            .getBookmakers(user, 'odd-variations')
            .then((res) => {
                setDroppingBookmakers(res.data.bookmakers.reduce((acc, item) => {
                    acc[item._id] = item;
                    acc[item._id].id = Number(item._id);
                    return acc;
                }, {}))
            }).catch(e => console.log(e))
    }, []);

    useEffect(() => {
        tournamentServices
            .getTree(user)
            .then((res) => {
                setAllTournaments(res.data)
                setTournaments(Object.entries(res.data).flatMap(([sportId, sport]) =>
                    Object.entries(sport).flatMap(([categoryId, category]) =>
                        category.tournaments.map(tournament => `${sportId}-${categoryId}-${tournament.id}`)
                    )
                ))
            }).catch(e => console.log(e))
    }, []);

    useEffect(() => {
        sessionServices.product(user, 'oddvariations').catch(e => console.log(e))
    }, []);

    const handleBookmakersDropdown = (selectedOptions) => {
        const allBookmakers = Object.values(droppingBookmakers).filter(b => userBookmakers.includes(b.id)).map(bookmaker => bookmaker.id);
        if (!bookmakers.includes('all')) {
            if (selectedOptions.includes('all')) {
                setBookmakers(['all', ...allBookmakers])
            } else {
                if (selectedOptions.length === allBookmakers.length) {
                    setBookmakers(['all', ...allBookmakers])
                } else {
                    setBookmakers(selectedOptions)
                }
            }
        } else {
            if (!selectedOptions.includes('all')) {
                setBookmakers([])
            } else {
                setBookmakers(selectedOptions.filter(o => o !== 'all'))
            }
        }
    };

    const handleThreshold = (value) => {
        setThreshold(value)
    }

    const handleFrom = (value) => {
        setFrom(value)
    }

    const handleTo = (value) => {
        setTo(value)
    }

    const handleDate = (value) => {
        setDate(value)
    }

    const handleTournaments = (value) => {
        setTournaments(value)
    }

    const handleTournamentSelect = (value, node) => {
        const nodeData = node.value.split('-')
        const nodeId = nodeData[nodeData.length - 1]
        if (nodeData.length === 3) {
            let newTournaments = allTournaments
            tournamentServices
                .getAllEvents(nodeId, user).then((res) => {
                newTournaments[nodeData[0]][nodeData[1]].tournaments.find((t) => t.id.toString() === nodeId).events = res.data
                setAllTournaments(newTournaments)
            }).catch((e) => console.log(e))
        }
    }

    const handleMarkets = (value) => {
        setMarkets(value)
    }

    const handleSearch = (e) => {
        setSearch(e.target.value)
    }

    const handleHide = (v) => {
        setHide([...hide, v])
    }

    const isValid = (drop) => {
        const expire = new Date()
        expire.setHours(23)
        expire.setMinutes(59)
        expire.setSeconds(59)
        expire.setDate(expire.getDate() + date - 1)
        const startdt = new Date(drop.d)
        return ((drop.e && drop.c && drop.s && drop.t && drop.bId !== 0)
                && bookmakers.includes(drop.bId)
                && markets.includes(drop.mId.toString().split('_')[0])
                && Math.abs(drop.v) >= threshold)
            && showFrom < drop.tm
            && !hide.includes((`${drop.bId}#${drop.id}#${drop.tm}`) || '')
            && (drop.e.toLowerCase().includes(search.toLowerCase())
                || drop.t.toLowerCase().includes(search.toLowerCase())
                || drop.c.toLowerCase().includes(search.toLowerCase()))
            && (
                ((from !== 1 && to === 1) && Object.values(drop.n)[drop.vId] >= from)
                || ((to !== 1 && from === 1) && Object.values(drop.n)[drop.vId] <= to)
                || ((to !== 1 && from !== 1) && Object.values(drop.n)[drop.vId] >= from && Object.values(drop.n)[drop.vId] <= to)
                || (from === 1 && to === 1)
            ) && (
                tournaments.includes(drop.sId.toString())
                || tournaments.includes(drop.sId.toString() + '-' + drop.cId.toString())
                || tournaments.includes(drop.sId.toString() + '-' + drop.cId.toString() + '-' + drop.tId.toString())
                || tournaments.includes(drop.id.toString())
            ) &&
            (
                (date === 0)
                || (startdt > new Date() && startdt <= expire)
            ) && (
                !onlyRemoved || Object.values(drop.n).every((n) => n === 1)
            );
    }

    const validItems = () => {
        let result = []
        Object.keys(data).forEach(k => {
            if (bookmakers.includes(parseInt(k))) {
                result = result.concat(data[k])
            }
        });
        return result
            .filter((i) => isValid(i))
            .sort((a, b) => a.tm === b.tm ? a.id - b.id : b.tm - a.tm)
            .slice(0, 200);
    }

    useEffect(() => {
        if (socket) {
            socket.on("lastDrop", (drop) => {
                setLastDrop(drop)
                setData(prevData => {
                    let newData = {...prevData};
                    if (!newData[drop.bId]) {
                        newData[drop.bId] = [];
                    }
                    newData[drop.bId].unshift(drop);
                    newData[drop.bId] = newData[drop.bId].slice(0, 100);
                    return newData;
                });
            });
        }
    }, [socket]);


    useEffect(() => {
        const prevFilters = filtersRef.current;
        const prevSearch = lastSearch.current;
        const prevHide = lastHide.current;
        const currentFilters = {
            bookmakers,
            markets,
            threshold,
            date,
            search,
            from,
            to,
            showFrom,
            tournaments,
            hide,
            onlyRemoved
        };
        let items
        if (JSON.stringify(prevFilters) === JSON.stringify(currentFilters) || search !== prevSearch || hide.join('') !== prevHide.join('')) {
            items = lastDrop ? isValid(lastDrop) ? [lastDrop].concat(droppingOddsList).sort((a, b) => a.tm === b.tm ? a.id - b.id : b.tm - a.tm).slice(0, 200) : droppingOddsList : droppingOdds
        } else {
            items = validItems();
        }
        const droppingList = items
        setDroppingOddsList(droppingList)
        items = items.filter((i) => isValid(i))
            .sort((a, b) => a.tm === b.tm ? a.id - b.id : b.tm - a.tm)
            .slice(0, 200);
        if (sound) {
            if (JSON.stringify(prevFilters) === JSON.stringify(currentFilters)) {
                if (items[0] && items[0].tm) {
                    if (Math.floor(items[0].tm) > lastUpdate.current) {
                        beepPlayer.play();
                        lastUpdate.current = items[0].tm;
                    }
                }
            } else {
                if (items[0] && items[0].tm) {
                    lastUpdate.current = items[0].tm;
                }
            }
        }
        filtersRef.current = currentFilters;
        lastSearch.current = search
        lastHide.current = hide
        setDroppingOdds(items);
    }, [lastDrop, bookmakers, markets, threshold, date, search, from, to, showFrom, tournaments, hide, onlyRemoved]);

    const handleLogout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("bookmaker")
        localStorage.removeItem("products")
        localStorage.removeItem("user")
        window.location.reload(true);
    }

    return (<ConfigProvider
        theme={{
            algorithm: theme.darkAlgorithm,
            token: {
                colorBgContainer: "#283038"
            }
        }}>
        <div className="container dropping" data-bs-theme="dark">
            <div className='sidebet-container shadow no-selection p-1'>
                <div className="row mt-3">
                    <div className="mt-2 d-flex sidebet-header">
                        <div style={{width: '22%'}} className='mt-2 dropping-bookmakers'>
                            <svg className='sidebet-icon' xmlns="http://www.w3.org/2000/svg" width="16px" height="16px"
                                 viewBox="0 0 16 16"
                                 version="1.1">
                                <path
                                    d="M 0.160156 1.039062 L 0 1.117188 L 0 4.636719 L 0.078125 8.230469 L 5.113281 8.230469 L 5.113281 9.429688 C 5.113281 10.546875 5.113281 10.707031 5.273438 11.265625 C 5.59375 12.144531 5.992188 12.707031 6.632812 13.34375 C 7.75 14.464844 8.710938 14.863281 10.308594 14.941406 C 11.425781 14.941406 11.988281 14.863281 12.945312 14.382812 C 14.304688 13.746094 15.261719 12.625 15.742188 11.1875 C 15.902344 10.628906 15.902344 10.386719 15.902344 9.507812 L 15.820312 8.070312 C 15.34375 6.550781 14.304688 5.273438 12.945312 4.636719 C 11.988281 4.15625 11.265625 3.996094 10.226562 3.996094 L 9.507812 4.074219 L 9.507812 1.117188 L 9.269531 1.039062 Z M 0.800781 1.757812 L 0.558594 1.917969 L 0.480469 1.757812 C 0.480469 1.519531 0.558594 1.519531 0.71875 1.519531 L 0.957031 1.519531 Z M 8.152344 1.839844 C 8.3125 2.078125 8.46875 2.238281 8.710938 2.316406 L 8.949219 2.476562 L 8.949219 4.234375 L 8.628906 4.316406 C 8.152344 4.476562 7.671875 4.714844 7.113281 5.113281 L 6.632812 5.515625 L 1.519531 5.515625 L 1.359375 5.195312 L 0.800781 4.636719 L 0.480469 4.476562 L 0.480469 2.476562 L 0.71875 2.398438 C 0.957031 2.316406 1.4375 1.839844 1.4375 1.597656 L 4.714844 1.519531 L 7.992188 1.519531 Z M 8.949219 1.679688 C 8.949219 1.917969 8.949219 1.917969 8.789062 1.839844 C 8.550781 1.679688 8.550781 1.519531 8.710938 1.519531 C 8.949219 1.519531 8.949219 1.597656 8.949219 1.757812 Z M 11.507812 4.636719 L 12.625 6.550781 L 13.585938 6.792969 C 14.785156 6.953125 14.785156 6.953125 14.941406 7.351562 C 15.183594 7.75 15.421875 8.46875 15.421875 8.789062 C 15.421875 8.949219 15.183594 9.191406 14.625 9.828125 L 13.824219 10.628906 L 14.0625 11.746094 L 14.222656 12.867188 L 13.824219 13.183594 L 12.945312 13.824219 L 12.464844 14.0625 L 11.507812 13.503906 L 10.46875 13.023438 L 9.429688 13.503906 L 8.46875 14.0625 L 7.992188 13.824219 L 7.191406 13.183594 L 6.710938 12.785156 L 6.953125 11.667969 L 7.113281 10.546875 L 6.3125 9.75 L 5.515625 8.949219 L 5.59375 8.46875 C 5.753906 7.832031 6.152344 6.953125 6.3125 6.871094 L 8.3125 6.632812 L 8.871094 5.671875 L 9.429688 4.636719 C 9.507812 4.476562 11.265625 4.476562 11.507812 4.636719 Z M 8.390625 5.515625 C 8.070312 6.074219 8.070312 6.152344 7.832031 6.234375 L 6.632812 6.3125 C 6.632812 6.074219 8.3125 4.875 8.628906 4.875 C 8.710938 4.875 8.628906 5.113281 8.390625 5.515625 Z M 12.867188 5.113281 C 13.34375 5.355469 14.304688 6.152344 14.304688 6.3125 L 12.867188 6.152344 L 12.304688 4.953125 C 12.304688 4.875 12.386719 4.875 12.867188 5.113281 Z M 0.878906 5.355469 C 0.957031 5.515625 0.957031 5.515625 0.71875 5.515625 C 0.480469 5.515625 0.480469 5.515625 0.480469 5.273438 C 0.480469 5.035156 0.480469 5.035156 0.640625 5.113281 Z M 6.152344 6.152344 C 5.992188 6.3125 0.480469 6.3125 0.480469 6.152344 C 0.480469 5.992188 0.878906 5.992188 3.355469 5.992188 C 5.914062 5.992188 6.234375 5.992188 6.152344 6.152344 Z M 5.671875 6.871094 C 3.976562 7.085938 2.261719 7.113281 0.558594 6.953125 C 0.320312 6.710938 0.640625 6.710938 3.117188 6.710938 C 5.515625 6.710938 5.671875 6.710938 5.671875 6.871094 Z M 5.355469 7.589844 C 5.273438 7.671875 4.714844 7.75 2.875 7.75 C 0.800781 7.75 0.480469 7.75 0.480469 7.589844 L 2.957031 7.511719 Z M 6.074219 10.226562 L 6.550781 10.707031 L 6.472656 11.425781 L 6.3125 12.144531 C 6.152344 12.144531 5.832031 11.347656 5.671875 10.707031 C 5.515625 10.070312 5.433594 9.75 5.59375 9.75 Z M 15.421875 10.226562 C 15.34375 10.707031 15.101562 11.507812 14.863281 11.90625 L 14.625 12.226562 L 14.542969 11.507812 L 14.382812 10.789062 L 14.863281 10.226562 L 15.421875 9.75 Z M 11.1875 13.90625 C 11.828125 14.304688 11.828125 14.304688 11.585938 14.382812 C 11.265625 14.464844 9.507812 14.464844 9.347656 14.304688 C 9.191406 14.222656 9.191406 14.222656 9.828125 13.90625 L 10.46875 13.585938 Z M 11.1875 13.90625 "
                                    fill="white" fillOpacity="0.702" stroke='white' strokeWidth={0.25}/>
                                <path
                                    d="M 4.316406 2.316406 C 3.035156 2.875 3.355469 4.714844 4.714844 4.714844 C 5.992188 4.714844 6.472656 3.195312 5.433594 2.476562 C 5.195312 2.238281 4.554688 2.238281 4.316406 2.316406 Z M 5.273438 2.957031 C 5.515625 3.195312 5.59375 3.515625 5.433594 3.835938 C 5.195312 4.316406 4.636719 4.394531 4.234375 3.996094 C 3.515625 3.355469 4.554688 2.316406 5.273438 2.957031 Z M 9.269531 7.75 C 8.3125 8.46875 8.152344 8.628906 8.152344 8.789062 L 8.550781 10.226562 L 9.03125 11.425781 L 10.46875 11.507812 L 11.988281 11.425781 L 12.867188 8.710938 C 12.867188 8.628906 10.628906 6.953125 10.46875 6.953125 Z M 12.304688 8.871094 L 11.988281 9.910156 L 11.585938 10.949219 L 10.46875 11.027344 L 9.347656 11.027344 L 9.03125 9.988281 L 8.710938 8.871094 L 9.589844 8.152344 L 10.46875 7.511719 L 11.347656 8.152344 Z M 12.304688 8.871094 "
                                    fill="white" fillOpacity="0.702" stroke='white' strokeWidth={0.25}/>
                            </svg>
                            <Select
                                mode='multiple'
                                showSearch
                                style={{
                                    minWidth: '100%',
                                    maxWidth: '300px'
                                }}
                                placeholder="Select bookmakers"
                                optionFilterProp="children"
                                onChange={handleBookmakersDropdown}
                                value={bookmakers}
                                maxTagCount={1}
                                filterOption={(input, option) =>
                                    (option?.label ?? '')
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                }
                                options={[{
                                    value: 'all',
                                    label: 'All'
                                }, ...Object.values(droppingBookmakers)
                                    .filter(b => userBookmakers.includes(b.name))
                                    .filter(book => (book.id !== 0 && !book.disabled))
                                    .sort((a, b) => a.name.localeCompare(b.name))
                                    .map((bookmaker) => {
                                        return {
                                            value: bookmaker.id,
                                            label: bookmaker.name
                                        }
                                    })]}
                            />
                        </div>
                        <div style={{width: '12%'}} className='mt-2 dropping-filter mx-2'>
                            <svg className='sidebet-icon' xmlns="http://www.w3.org/2000/svg" width="16" height="16">
                                <path d="M4 0 3 1v1l1 1 1-1V1L4 0Zm8 0-1 1v1l1 1 1-1V1l-1-1Zm0 0"
                                      fill="white" fillOpacity="0.702"/>
                                <path d="M14 2h-1l-1 1-1-1H5L4 3 3 2H2L1 3v12l1 1h12l1-1V3l-1-1Zm0 13H2V5h12Zm0 0"
                                      fill="white" fillOpacity="0.702"/>
                                <path
                                    d="M9 7h3l1-1H9v1Zm0 2h4l-1-1H9v1Zm0 2h4l-1-1H9v1Zm0 2h4l-1-1H9v1ZM4 7h3V6H3l1 1Zm0 2h3V8H4L3 9h1Zm0 2h3v-1H4l-1 1h1Zm0 2h3v-1H4l-1 1h1Zm0 0"
                                    fill="white" fillOpacity="0.702"/>
                            </svg>
                            <Select
                                style={{
                                    width: '95%'
                                }}
                                placeholder='Date'
                                value={date}
                                onChange={handleDate}
                                options={[
                                    {value: 0, label: 'All'},
                                    {value: 1, label: 'Today'},
                                    {value: 2, label: 'Today + 1'},
                                    {value: 3, label: 'Today + 2'},
                                    {value: 4, label: 'Today + 3'},
                                    {value: 5, label: 'Today + 4'},
                                    {value: 6, label: 'Today + 5'},
                                    {value: 7, label: 'Today + 6'},
                                ]}
                            />
                        </div>
                        <div style={{width: '16%'}} className='mt-2 dropping-filter'>
                            <svg className='sidebet-icon' width="16" height="16" viewBox="0 0 16 16" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M7.78975 13.1158C7.49265 13.1158 7.24628 12.8694 7.24628 12.5723V11.0506C7.24628 10.7535 7.49265 10.5071 7.78975 10.5071C8.08685 10.5071 8.33322 10.7535 8.33322 11.0506V12.5723C8.33322 12.8694 8.08685 13.1158 7.78975 13.1158Z"
                                    fill="white" fillOpacity="0.702"/>
                                <path
                                    d="M11.9564 15.5795H3.62314V14.3114C3.62314 13.21 4.51443 12.3187 5.61587 12.3187H9.96364C11.0651 12.3187 11.9564 13.21 11.9564 14.3114V15.5795ZM4.71008 14.4926H10.8694V14.3114C10.8694 13.8114 10.4636 13.4056 9.96364 13.4056H5.61587C5.11587 13.4056 4.71008 13.8114 4.71008 14.3114V14.4926Z"
                                    fill="white" fillOpacity="0.702"/>
                                <path
                                    d="M12.1375 15.5795H3.44197C3.14487 15.5795 2.8985 15.3331 2.8985 15.036C2.8985 14.7389 3.14487 14.4926 3.44197 14.4926H12.1375C12.4346 14.4926 12.681 14.7389 12.681 15.036C12.681 15.3331 12.4346 15.5795 12.1375 15.5795Z"
                                    fill="white" fillOpacity="0.702"/>
                                <path
                                    d="M12.3406 8.10866C12.1885 8.10866 12.0363 8.04345 11.9276 7.92026C11.7899 7.76084 11.7537 7.53621 11.8406 7.3478C12.087 6.78259 12.2102 6.18112 12.2102 5.5507V3.37681C12.2102 3.12319 12.1667 2.87682 12.0798 2.61595C12.0725 2.59421 12.0653 2.56523 12.058 2.53624C12.0363 2.42755 12.0291 2.31885 12.0291 2.21741C12.0291 1.92031 12.2754 1.67393 12.5725 1.67393H13.0073C14.3044 1.67393 15.3623 2.76088 15.3623 4.10144C15.3623 5.21012 14.9058 6.30431 14.116 7.09418C14.1015 7.10868 14.058 7.14491 14.0508 7.15215C13.6232 7.50722 13.1377 7.90577 12.4856 8.08692C12.4348 8.10142 12.3914 8.10866 12.3406 8.10866ZM13.2464 2.78262C13.2827 2.97827 13.2972 3.18116 13.2972 3.37681V5.5507C13.2972 5.84779 13.2754 6.1304 13.2319 6.42028C13.2754 6.38405 13.3116 6.35506 13.3551 6.3188C13.9348 5.7391 14.2754 4.92752 14.2754 4.10144C14.2754 3.44927 13.8334 2.89856 13.2464 2.78262Z"
                                    fill="white" fillOpacity="0.702"/>
                                <path
                                    d="M3.02895 8.07967C2.97098 8.07967 2.92025 8.07242 2.86228 8.05068C2.26809 7.86228 1.71012 7.51446 1.24636 7.0507C0.413038 6.13042 0 5.12319 0 4.05798C0 2.73916 1.03622 1.70294 2.35504 1.70294H2.82605C3.00721 1.70294 3.18112 1.79714 3.28257 1.94932C3.38401 2.10149 3.39851 2.29714 3.32604 2.4638C3.2101 2.72467 3.15213 3.02177 3.15213 3.33336V5.50724C3.15213 6.13042 3.27532 6.73911 3.52894 7.31881C3.61589 7.51446 3.57242 7.73909 3.43474 7.89851C3.32604 8.01445 3.18112 8.07967 3.02895 8.07967ZM2.10142 2.81162C1.51447 2.92756 1.08694 3.4348 1.08694 4.05798C1.08694 4.84783 1.40578 5.60869 2.03621 6.30433C2.06519 6.34056 2.10142 6.36955 2.13765 6.39853C2.08693 6.10143 2.06519 5.80434 2.06519 5.50724V3.33336C2.06519 3.15944 2.07968 2.98553 2.10142 2.81162Z"
                                    fill="white" fillOpacity="0.702"/>
                                <path
                                    d="M7.68078 11.2317C4.58662 11.2317 2.06491 8.71003 2.06491 5.61587V3.44198C2.06491 1.54346 3.60837 0 5.50689 0H9.85466C11.7532 0 13.2966 1.54346 13.2966 3.44198V5.61587C13.2966 8.71003 10.7749 11.2317 7.68078 11.2317ZM5.50689 1.08694C4.20981 1.08694 3.15185 2.1449 3.15185 3.44198V5.61587C3.15185 8.11584 5.18081 10.1448 7.68078 10.1448C10.1807 10.1448 12.2097 8.11584 12.2097 5.61587V3.44198C12.2097 2.1449 11.1517 1.08694 9.85466 1.08694H5.50689Z"
                                    fill="white" fillOpacity="0.702"/>
                            </svg>
                            <TreeSelect
                                showSearch
                                treeNodeFilterProp="title"
                                value={tournaments}
                                treeData={Object.keys(allTournaments).map((s) => {
                                    return {
                                        title: parseInt(s) === 1 ? 'Soccer' : parseInt(s) === 2 ? 'Basket' : 'Tennis',
                                        value: s,
                                        key: s,
                                        children: Object.values(allTournaments[s]).sort((a, b) => a.name.localeCompare(b.name)).map(c => {
                                                return {
                                                    title: c.name,
                                                    value: s + '-' + c.id,
                                                    key: s + '-' + c.id,
                                                    children: c.tournaments.sort((a, b) => a.name.localeCompare(b.name)).map(t => {
                                                        return {
                                                            title: t.name,
                                                            value: s + '-' + c.id + '-' + t.id,
                                                            key: s + '-' + c.id + '-' + t.id,
                                                            children: t['events'] ? t['events'].sort((a, b) => a.name.localeCompare(b.name)).map(e => {
                                                                return {
                                                                    title: e.name,
                                                                    value: e._id,
                                                                    key: e._id
                                                                }
                                                            }) : []
                                                        }
                                                    })
                                                }
                                            }
                                        )
                                    }
                                })}
                                dropdownStyle={{width: 'max-content'}}
                                style={{width: '90%'}}
                                onChange={handleTournaments}
                                maxTagCount={0}
                                onSelect={handleTournamentSelect}
                                treeCheckable={true}
                                showCheckedStrategy={TreeSelect}
                                placeholder='Tournaments'
                            />
                        </div>
                        <div style={{width: "11.5%"}} className='mt-2 dropping-filter'>
                            <Form.Item label={'Odd Min'}>
                                <InputNumber
                                    style={{
                                        width: '62px'
                                    }}
                                    min={1}
                                    step={0.1}
                                    value={from}
                                    onChange={handleFrom}
                                />
                            </Form.Item>
                        </div>
                        <div style={{width: "12%"}} className='mt-2 dropping-filter'>
                            <Form.Item label={'Odd Max'}>
                                <InputNumber
                                    style={{
                                        width: '62px'
                                    }}
                                    min={1}
                                    step={0.1}
                                    value={to}
                                    onChange={handleTo}
                                />
                            </Form.Item>
                        </div>
                        <div style={{width: "12.5%"}} className='mt-2 dropping-filter'>
                            <Form.Item label={'Threshold '}>
                                <InputNumber
                                    style={{
                                        width: '62px'
                                    }}
                                    min={0}
                                    value={threshold}
                                    onChange={handleThreshold}
                                />
                            </Form.Item>
                        </div>
                        <div style={{width: '3.5%'}} className='dropping-filter mx-1'>
                            <Button
                                title={sound ? 'Disable Beep' : 'Enable Beep'}
                                className='sidebet-button'
                                onClick={() => setSound(!sound)}
                            >
                                {sound ?
                                    <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 100 100"
                                         version="1.0">
                                        <path fill="white" fillOpacity="0.702"
                                              d="m31.6 8.6-10.8 9h-8.9C.1 17.6 0 17.8 0 34.8c0 15.9-.1 15.8 11.8 15.8h8.7l11 9c6 5 11.4 8.9 12 8.7 1.4-.5 1.4-67.9 0-68.3-.5-.2-5.9 3.7-11.9 8.6zM71 3.1l-2.4 2.5 2.6 2.8c13 13.9 13.9 35.3 2.2 49.1l-3.6 4.2 2.3 2.5c1.2 1.3 2.8 2.4 3.5 2.4 1.9 0 9.1-10.5 11.5-16.9 4.2-11.3 3.4-25.3-2.1-36.2C82.9 9.5 75.4.6 74 .6c-.3 0-1.7 1.1-3 2.5z"/>
                                        <path fill="white" fillOpacity="0.702"
                                              d="M56.7 17.4 54 20.3l2.1 1.9c3.3 3 4.9 6.9 4.9 11.9 0 4.9-1 7.7-4.1 11.1-1.9 2-1.9 2.1 1.1 4.9 2.9 2.8 3 2.8 5 1 3.7-3.3 6.4-10.5 6.4-17 0-5-.6-7.2-3-11.5-1.7-3-4-6-5-6.7-1.8-1.1-2.3-1-4.7 1.5z"/>
                                    </svg> :
                                    <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 100 100"
                                         version="1.0">
                                        <path fill="white" fillOpacity="0.702"
                                              d="m30.7 8.7-10.9 9h-8.7c-5.4 0-9.2.5-9.9 1.2-.8.8-1.2 5.7-1.2 15.5 0 16.9-.4 16.3 12.2 16.3l8.3.1 10.9 8.9c8.6 7.2 11.2 8.8 12.2 7.9C45.8 65.8 45.2.3 43 0c-.8-.1-6.4 3.8-12.3 8.7zm25 7.7L53 19.2l7.2 7.2 7.2 7.3-7.2 7.3-7.2 7.3 3 2.9 3 2.9 7.3-7.2 7.2-7.2 7.3 7.2 7.2 7.3 2.7-2.8 2.8-2.7-7.3-7.2-7.2-7.3 7.2-7.2 7.2-7.3-2.9-3-2.9-3-7.3 7.2-7.3 7.2-7.3-7.2-7.2-7.2-2.8 2.7z"/>
                                    </svg>
                                }
                            </Button>
                        </div>
                        <div style={{width: '3.5%'}} className='dropping-filter mx-1'>
                            <Button
                                title='Clear Data'
                                className='sidebet-button'
                                onClick={() => {
                                    setShowFrom(Date.now() / 1000)
                                }}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 448 512">
                                    <path fill="white" fillOpacity="0.702"
                                          d="M135.2 17.7C140.6 6.8 151.7 0 163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm96 64c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16z"></path>
                                </svg>
                            </Button>
                        </div>
                        <div style={{width: '3.5%'}} className='dropping-filter mx-1'>
                            <Button
                                title='Clear Filters'
                                className='sidebet-button'
                                onClick={() => {
                                    setBookmakers([])
                                    setMarkets([])
                                    setTo(1)
                                    setFrom(1)
                                    setThreshold(3)
                                    setDate(0)
                                    setSearch('')
                                    setShowFrom(0)
                                    setTournaments([])
                                    setOnlyRemoved(false)
                                    setHide([])
                                }}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 32 32">
                                    <path
                                        d="M30 11.4 28.6 10 24 14.6 19.4 10 18 11.4l4.6 4.6-4.6 4.6 1.4 1.4 4.6-4.6 4.6 4.6 1.4-1.4-4.6-4.6z"
                                        fill="white" fillOpacity="0.702"/>
                                    <path
                                        d="M4 4a2 2 0 0 0-2 2v3.2a2 2 0 0 0 .6 1.4L10 18v8a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-2h-2v2h-4v-8.8l-.6-.6L4 9.2V6h20v2h2V6a2 2 0 0 0-2-2z"
                                        fill="white" fillOpacity="0.702"/>
                                    <path fill="none" d="M0 0h32v32H0z"/>
                                </svg>
                            </Button>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="d-flex sidebet-header">
                        <div style={{width: '21.5%'}} className='dropping-bookmakers'>
                            <svg className='sidebet-icon' xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                 viewBox="0 0 16 15">
                                <path
                                    d="M6.504 0C8.3 0 9.926.7 11.102 1.832c1.171 1.129 1.902 2.688 1.902 4.414v.008a6.063 6.063 0 0 1-1.172 3.578l3.781 3.266.004.004.02.015v.004c.215.195.332.457.347.723.012.261-.074.527-.257.746h-.004l-.024.027-.023.024v.004a1.137 1.137 0 0 1-.754.328c-.27.015-.55-.067-.774-.246h-.003l-.028-.024-.004-.004-3.867-3.34a5.19 5.19 0 0 1-.351.22 6.68 6.68 0 0 1-3.39.918H6.5c-1.793 0-3.422-.7-4.598-1.833C.73 9.535.004 7.977 0 6.254v-.008c0-1.723.73-3.285 1.906-4.418A6.627 6.627 0 0 1 6.5 0Zm0 1.402H6.5A5.13 5.13 0 0 0 2.937 2.82a4.734 4.734 0 0 0-1.48 3.426h.004v.008h-.004a4.747 4.747 0 0 0 1.48 3.422A5.13 5.13 0 0 0 6.5 11.094h.008c1.39 0 2.648-.543 3.562-1.418a4.746 4.746 0 0 0 1.477-3.426v-.004c0-1.336-.567-2.547-1.477-3.426a5.147 5.147 0 0 0-3.566-1.418Zm0 0"
                                    fill="white" fillOpacity="0.702"/>
                            </svg>
                            <Input
                                style={{
                                    width: '100%'
                                }}
                                value={search}
                                onChange={handleSearch}
                                placeholder={'Search'}
                            />
                        </div>
                        <div style={{width: '22%'}} className='dropping-bookmakers'>
                            <svg className='sidebet-icon' xmlns="http://www.w3.org/2000/svg" width="16px" height="16px"
                                 viewBox="0 0 16 16"
                                 version="1.1">
                                <path
                                    d="M 0.160156 1.039062 L 0 1.117188 L 0 4.636719 L 0.078125 8.230469 L 5.113281 8.230469 L 5.113281 9.429688 C 5.113281 10.546875 5.113281 10.707031 5.273438 11.265625 C 5.59375 12.144531 5.992188 12.707031 6.632812 13.34375 C 7.75 14.464844 8.710938 14.863281 10.308594 14.941406 C 11.425781 14.941406 11.988281 14.863281 12.945312 14.382812 C 14.304688 13.746094 15.261719 12.625 15.742188 11.1875 C 15.902344 10.628906 15.902344 10.386719 15.902344 9.507812 L 15.820312 8.070312 C 15.34375 6.550781 14.304688 5.273438 12.945312 4.636719 C 11.988281 4.15625 11.265625 3.996094 10.226562 3.996094 L 9.507812 4.074219 L 9.507812 1.117188 L 9.269531 1.039062 Z M 0.800781 1.757812 L 0.558594 1.917969 L 0.480469 1.757812 C 0.480469 1.519531 0.558594 1.519531 0.71875 1.519531 L 0.957031 1.519531 Z M 8.152344 1.839844 C 8.3125 2.078125 8.46875 2.238281 8.710938 2.316406 L 8.949219 2.476562 L 8.949219 4.234375 L 8.628906 4.316406 C 8.152344 4.476562 7.671875 4.714844 7.113281 5.113281 L 6.632812 5.515625 L 1.519531 5.515625 L 1.359375 5.195312 L 0.800781 4.636719 L 0.480469 4.476562 L 0.480469 2.476562 L 0.71875 2.398438 C 0.957031 2.316406 1.4375 1.839844 1.4375 1.597656 L 4.714844 1.519531 L 7.992188 1.519531 Z M 8.949219 1.679688 C 8.949219 1.917969 8.949219 1.917969 8.789062 1.839844 C 8.550781 1.679688 8.550781 1.519531 8.710938 1.519531 C 8.949219 1.519531 8.949219 1.597656 8.949219 1.757812 Z M 11.507812 4.636719 L 12.625 6.550781 L 13.585938 6.792969 C 14.785156 6.953125 14.785156 6.953125 14.941406 7.351562 C 15.183594 7.75 15.421875 8.46875 15.421875 8.789062 C 15.421875 8.949219 15.183594 9.191406 14.625 9.828125 L 13.824219 10.628906 L 14.0625 11.746094 L 14.222656 12.867188 L 13.824219 13.183594 L 12.945312 13.824219 L 12.464844 14.0625 L 11.507812 13.503906 L 10.46875 13.023438 L 9.429688 13.503906 L 8.46875 14.0625 L 7.992188 13.824219 L 7.191406 13.183594 L 6.710938 12.785156 L 6.953125 11.667969 L 7.113281 10.546875 L 6.3125 9.75 L 5.515625 8.949219 L 5.59375 8.46875 C 5.753906 7.832031 6.152344 6.953125 6.3125 6.871094 L 8.3125 6.632812 L 8.871094 5.671875 L 9.429688 4.636719 C 9.507812 4.476562 11.265625 4.476562 11.507812 4.636719 Z M 8.390625 5.515625 C 8.070312 6.074219 8.070312 6.152344 7.832031 6.234375 L 6.632812 6.3125 C 6.632812 6.074219 8.3125 4.875 8.628906 4.875 C 8.710938 4.875 8.628906 5.113281 8.390625 5.515625 Z M 12.867188 5.113281 C 13.34375 5.355469 14.304688 6.152344 14.304688 6.3125 L 12.867188 6.152344 L 12.304688 4.953125 C 12.304688 4.875 12.386719 4.875 12.867188 5.113281 Z M 0.878906 5.355469 C 0.957031 5.515625 0.957031 5.515625 0.71875 5.515625 C 0.480469 5.515625 0.480469 5.515625 0.480469 5.273438 C 0.480469 5.035156 0.480469 5.035156 0.640625 5.113281 Z M 6.152344 6.152344 C 5.992188 6.3125 0.480469 6.3125 0.480469 6.152344 C 0.480469 5.992188 0.878906 5.992188 3.355469 5.992188 C 5.914062 5.992188 6.234375 5.992188 6.152344 6.152344 Z M 5.671875 6.871094 C 3.976562 7.085938 2.261719 7.113281 0.558594 6.953125 C 0.320312 6.710938 0.640625 6.710938 3.117188 6.710938 C 5.515625 6.710938 5.671875 6.710938 5.671875 6.871094 Z M 5.355469 7.589844 C 5.273438 7.671875 4.714844 7.75 2.875 7.75 C 0.800781 7.75 0.480469 7.75 0.480469 7.589844 L 2.957031 7.511719 Z M 6.074219 10.226562 L 6.550781 10.707031 L 6.472656 11.425781 L 6.3125 12.144531 C 6.152344 12.144531 5.832031 11.347656 5.671875 10.707031 C 5.515625 10.070312 5.433594 9.75 5.59375 9.75 Z M 15.421875 10.226562 C 15.34375 10.707031 15.101562 11.507812 14.863281 11.90625 L 14.625 12.226562 L 14.542969 11.507812 L 14.382812 10.789062 L 14.863281 10.226562 L 15.421875 9.75 Z M 11.1875 13.90625 C 11.828125 14.304688 11.828125 14.304688 11.585938 14.382812 C 11.265625 14.464844 9.507812 14.464844 9.347656 14.304688 C 9.191406 14.222656 9.191406 14.222656 9.828125 13.90625 L 10.46875 13.585938 Z M 11.1875 13.90625 "
                                    fill="white" fillOpacity="0.702" stroke='white' strokeWidth={0.25}/>
                                <path
                                    d="M 4.316406 2.316406 C 3.035156 2.875 3.355469 4.714844 4.714844 4.714844 C 5.992188 4.714844 6.472656 3.195312 5.433594 2.476562 C 5.195312 2.238281 4.554688 2.238281 4.316406 2.316406 Z M 5.273438 2.957031 C 5.515625 3.195312 5.59375 3.515625 5.433594 3.835938 C 5.195312 4.316406 4.636719 4.394531 4.234375 3.996094 C 3.515625 3.355469 4.554688 2.316406 5.273438 2.957031 Z M 9.269531 7.75 C 8.3125 8.46875 8.152344 8.628906 8.152344 8.789062 L 8.550781 10.226562 L 9.03125 11.425781 L 10.46875 11.507812 L 11.988281 11.425781 L 12.867188 8.710938 C 12.867188 8.628906 10.628906 6.953125 10.46875 6.953125 Z M 12.304688 8.871094 L 11.988281 9.910156 L 11.585938 10.949219 L 10.46875 11.027344 L 9.347656 11.027344 L 9.03125 9.988281 L 8.710938 8.871094 L 9.589844 8.152344 L 10.46875 7.511719 L 11.347656 8.152344 Z M 12.304688 8.871094 "
                                    fill="white" fillOpacity="0.702" stroke='white' strokeWidth={0.25}/>
                            </svg>
                            <TreeSelect
                                showSearch
                                mode='multiple'
                                treeNodeFilterProp="title"
                                value={markets}
                                treeData={Object.keys(allMarkets).map((s) => {
                                    return {
                                        title: s,
                                        value: s,
                                        key: s,
                                        children: Object.keys(allMarkets[s]).sort((a, b) => a.localeCompare(b)).map(c => {
                                                return {
                                                    title: c,
                                                    value: s + '-' + c,
                                                    key: s + '-' + c,
                                                    children: Object.values(allMarkets[s][c]).sort((a, b) => a.name.localeCompare(b.name)).map(t => {
                                                        return {
                                                            title: t.name,
                                                            value: t.id,
                                                            key: t.id
                                                        }
                                                    })
                                                }
                                            }
                                        )
                                    }
                                })}
                                dropdownStyle={{width: 'max-content'}}
                                style={{width: '100%', maxWidth: '300px'}}
                                onChange={handleMarkets}
                                maxTagCount="responsive"
                                treeCheckable={true}
                                showCheckedStrategy={TreeSelect}
                                placeholder='Markets'
                            />
                        </div>
                        <div>
                            <Checkbox checked={onlyRemoved} onChange={() => setOnlyRemoved(!onlyRemoved)}
                                      className='m-1'>
                                Only Removed
                            </Checkbox>
                        </div>
                    </div>
                </div>

                <hr className='sidebet-line'></hr>
                <Table
                    columns={[{
                        align: 'center',
                        width: '6%',
                        title: 'Sport',
                        render: (drop) => (
                            <div title={drop.s}>
                                {drop.sId === 1 ? (
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 512 512">
                                        <path fill="#e6e9ed" d="M256 512A255 255 0 0 1 0 256 254 254 0 0 1 256 0a254 254 0 0 1 256 256 254 254 0 0 1-256 256z"/>
                                        <path fill="#434a54"
                                              d="m330 192-103-33c-4-2-9 0-12 3l-63 88c-3 3-3 9 0 12l63 88a11 11 0 0 0 12 3l103-33c4-1 7-5 7-10V202c0-5-3-9-7-10zM35 169c-3-4-8-5-12-4l-2 1c-3 1-6 3-7 6l-1 5c-18 53-17 110 1 162 1 4 4 6 7 7l2 1h3c4 0 7-1 9-4l58-81c3-3 3-9 0-12l-58-81zm177 244c-3-4-8-6-12-4l-95 30c-4 2-7 6-7 11v2c0 3 1 6 4 8l4 3c44 32 96 49 150 49h5c3 0 6-2 8-5l1-1c3-4 3-9 0-13l-58-80zm287-92-1-1c-3-4-7-6-12-4l-95 30c-4 2-7 6-7 11v99c0 5 3 9 7 10l2 1a11 11 0 0 0 10-1l3-3c46-33 79-79 95-132 1-4 0-7-2-10zM391 165l95 31a11 11 0 0 0 12-4l1-1c2-3 3-6 2-10l-2-4c-17-54-50-99-96-131-3-2-7-2-10-1h-2c-4 2-7 6-7 11v99c0 5 3 9 7 10zM105 72l95 31a11 11 0 0 0 12-4l58-80c3-4 3-9 0-13l-1-2c-2-2-5-4-8-4h-5c-56 0-109 18-154 52-3 2-4 5-4 8v2c0 5 3 9 7 10z"/>
                                        <path fill="#fff"
                                              d="M492 156A255 255 0 0 0 256 0h-11a254 254 0 0 1 226 156 254 254 0 0 1-55 281 255 255 0 0 1-160 75 254 254 0 0 0 256-256c0-35-7-68-20-100z"
                                              opacity=".2"/>
                                    </svg>

                                ) : drop.sId === 2 ? (
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 56 56">
                                        <circle cx="28" cy="28" r="28" fill="#e57e25"/>
                                        <path fill="#38454f"
                                              d="M.7 30.2a13 13 0 0 1 13.9-2.6 52.7 52.7 0 0 0-8.2 18.2L8 47.5c.1-.1.3-.3.3-.5a50.7 50.7 0 0 1 8-18.3c2.6 2 3.9 5.2 3.6 9.4v.1a19.1 19.1 0 0 0 14.8 17c1.7-.4 3.3-1 4.8-1.6-3 .2-6.3-.5-9.3-2.3a16 16 0 0 1-8.3-13c.4-6.2-2-9.5-4.3-11.2 1.5-2 3-3.8 4.8-5.5a202 202 0 0 1 20.1 21.3l4.3 5.2 1.6-1.2-4.3-5.3a256.6 256.6 0 0 0-20.3-21.4c1.4-1.3 2.8-2.4 4.4-3.5 2.4 3 6.2 4.5 11 4.1a15 15 0 0 1 11.6 6.8c2.3 3.2 3.4 7 3.3 10.5.6-1.6 1.1-3.3 1.4-5-.6-2.4-1.6-4.6-3-6.7a17.6 17.6 0 0 0-13.3-7.6c-4.1.3-7.4-.9-9.4-3.3a50.7 50.7 0 0 1 17.7-7.6l-1.7-1.5a53 53 0 0 0-17 7.4A13 13 0 0 1 30.3.7l.4-.6L28 0v.6A14.7 14.7 0 0 0 27 15a53.4 53.4 0 0 0-4.7 3.8c-3.2-3-6.6-5.8-10-8.6L9 7.5 7.5 8.9l3.5 2.8c3.4 2.8 6.7 5.6 9.9 8.5a53.3 53.3 0 0 0-5.1 5.8l-.4-.2A15 15 0 0 0 .2 28H0l.1 2.8.6-.6z"/>
                                    </svg>
                                ) : (
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 56 56">
                                        <path fill="#d3ef30"
                                              d="M7 27.6a17 17 0 0 0 6.4 12.8c4 3.2 9.2 4.5 14.3 3.6 3-.5 6-2.1 8.7-4.5a35 35 0 0 0 4.4-5 18 18 0 0 0 2.5-17.2A17 17 0 0 0 28 6.7c-4.9.3-9-1-11.8-3.7a1 1 0 0 1-.2-.3A28 28 0 0 0 3 15.4l.3.2c2.8 2.9 4 7 3.8 12z"/>
                                        <path fill="#d3ef30"
                                              d="M28 0c-3.6 0-7 .7-10 1.9 2.3 2.1 5.8 3 10 2.8 8 .3 14.4 4.7 17.3 11.8a20 20 0 0 1-2.8 19.3c-1.3 1.8-3 3.6-4.6 5.1a19.8 19.8 0 0 1-13.3 5.4c-4.5 0-8.9-1.5-12.4-4.4a19 19 0 0 1-7-14.3c.3-4.3-.8-7.8-3-10.3A28 28 0 0 0 28 56a28 28 0 1 0 0-56z"/>
                                        <path fill="#fff"
                                              d="M5 27.5v.1a19 19 0 0 0 19.5 18.7A19.8 19.8 0 0 0 37.8 41c1.7-1.6 3.3-3.4 4.6-5.2a20 20 0 0 0 2.8-19.3A19 19 0 0 0 28 4.7c-4.2.3-7.7-.7-10-2.8-.8.2-1.4.5-2 .8 0 .1 0 .2.2.3 2.8 2.7 7 4 11.8 3.7a17 17 0 0 1 15.3 10.6 18 18 0 0 1-2.5 17.3 32.6 32.6 0 0 1-4.4 4.9c-2.7 2.4-5.7 4-8.7 4.5-5.1.9-10.4-.4-14.3-3.6A17 17 0 0 1 7 27.6c.3-5-1-9.1-3.8-12l-.3-.2a28 28 0 0 0-.9 2c2.2 2.4 3.3 5.9 3 10.1z"/>
                                    </svg>
                                )}
                            </div>
                        )
                    }, {
                        align: 'center',
                        width: '24%',
                        title: 'Event',
                        render: (drop) => (
                            <div style={{textAlign: 'left'}}>
                                <b>{drop.e}</b><br/>
                                {drop.t + ' - ' + drop.c}
                            </div>
                        )
                    }, {
                        align: 'center',
                        width: '9%',
                        title: 'Update',
                        render: (drop) => (
                            hoursFormatter(drop.tm)
                        )
                    }, {
                        align: 'center',
                        width: '6%',
                        title: 'Date',
                        render: (drop) => (
                            dateFormatterNoYear(drop.d)
                        )
                    }, {
                        align: 'center',
                        width: '8%',
                        title: 'Threshold',
                        render: (drop) => (
                            <div
                                className={Math.abs(drop.v) < 10 ? 'bg-secondary-subtle' : Math.abs(drop.v) < 15 ? 'bg-warning-subtle' : 'bg-danger-subtle'}>
                                <b> {drop.v.toFixed(2)} </b>
                            </div>
                        )
                    }, {
                        align: 'center',
                        width: '9%',
                        title: 'Bookmaker',
                        render: (drop) => (
                            droppingBookmakers[drop.bId]['name'].toUpperCase()
                        )
                    }, {
                        align: 'center',
                        width: '8%',
                        title: 'Market',
                        render: (drop) => {
                            const marketData = drop.mId.split('_')
                            const market = marketData[0]
                            const spread = marketData[1] ? (Number(marketData[1]) - 0.5).toString().replace('.', ',') : null
                            const sign = marketData[2]
                            return Markets[market].name + ' ' + (sign ? sign === 'U' ? 'Under - ' : sign === 'O' ? 'Over - ' : '' : '') + (spread ? spread : '')
                        }
                    }, {
                        align: 'center',
                        width: '5%',
                        title: '',
                        render: (drop) => (
                            <Button onClick={() => handleHide(`${drop.bId}#${drop.id}#${drop.tm}`)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 448 512">
                                    <path fill="white" fillOpacity="0.702"
                                          d="M135.2 17.7C140.6 6.8 151.7 0 163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm96 64c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16z"></path>
                                </svg>
                            </Button>
                        )
                    }, {
                        align: 'center',
                        width: '24%',
                        title: 'Odds',
                        render: (drop) => (
                            <table className='odds-table'>
                                <tbody>
                                <tr>
                                    {Object.keys(drop.p).map((k, i) => {
                                        const marketData = k.split('_')
                                        const market = marketData[0]
                                        const spread = marketData[1] ? (Number(marketData[1]) - 0.5).toString().replace('.', ',') : null
                                        const sign = marketData[2]
                                        return (
                                            <td className='text-center'
                                                style={{width: `${100 / Object.keys(drop.p).length}%`}}>
                                                <p className='odds-dark-bg'>{Markets[drop.mId.toString().split('_')[0]]['outcomes'][Object.keys(drop.p)[i]]?.['name'] || Markets[market].name + ' ' + (sign ? sign === 'U' ? 'Under - ' : sign === 'O' ? 'Over - ' : '' : '') + (spread ? spread : '')}</p>
                                                <p className='opacity-50 odds-light-bg'> {drop.p[Object.keys(drop.p)[i]].toFixed(2)}</p>
                                                <p className='position-relative odds-dark-bg'>
                                                    {!Object.values(drop.n).every((n) => n === 1) && drop.p[Object.keys(drop.p)[i]] !== drop.n[Object.keys(drop.p)[i]] &&
                                                        <svg className='position-absolute'
                                                             xmlns="http://www.w3.org/2000/svg"
                                                             style={{
                                                                 left: Object.keys(drop.p).length === 2 ? '20px' : '5px',
                                                                 top: '4px'
                                                             }} width="14" height="14"
                                                             viewBox="0 0 1024 1024" version="1.1">
                                                            <path
                                                                transform={drop.p[Object.keys(drop.p)[i]] > drop.n[Object.keys(drop.p)[i]] ? "scale(1, -1) translate(0, -1024)" : ""}
                                                                d="M952.576 554.858667q0 29.141333-21.141333 51.434667l-42.858667 42.858667q-21.717333 21.717333-52.010667 21.717333-30.848 0-51.434667-21.717333l-168-167.424 0 402.282667q0 29.717333-21.418667 48.277333t-51.712 18.581333l-73.152 0q-30.293333 0-51.712-18.581333t-21.418667-48.277333l0-402.282667-168 167.424q-20.565333 21.717333-51.434667 21.717333t-51.434667-21.717333l-42.858667-42.858667q-21.717333-21.717333-21.717333-51.434667 0-30.293333 21.717333-52.010667l372.010667-372.010667q20.010667-21.141333 51.434667-21.141333 30.848 0 52.010667 21.141333l372.010667 372.010667q21.141333 22.293333 21.141333 52.010667z"
                                                                fill={drop.p[Object.keys(drop.p)[i]] > drop.n[Object.keys(drop.p)[i]] ? "red" : "green"}
                                                                fillOpacity="0.5"/>
                                                        </svg>}
                                                    <b>{Object.values(drop.n).every((n) => n === 1) ? '-' : i === drop.vId ?
                                                        <u>{drop.n[Object.keys(drop.p)[i]].toFixed(2)}</u> : drop.n[Object.keys(drop.p)[i]].toFixed(2)}</b>
                                                </p>
                                            </td>)
                                    })}
                                </tr>
                                </tbody>
                            </table>
                        )
                    }]}
                    dataSource={[...droppingOdds]}
                    pagination={false}
                    scroll={{y: '50vh'}}
                />
            </div>
        </div>
    </ConfigProvider>)
}